import { useAuth } from "@stardeck-customer-apps/project-auth";
import { Loader2, Lock } from "lucide-react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { Button } from "@/components/button";

export function LoginPage() {
  const { user, isLoading, signIn } = useAuth();
  const navigate = useNavigate();

  // If already logged in, redirect to admin dashboard
  useEffect(() => {
    if (user && !isLoading) {
      navigate("/admin/reservations");
    }
  }, [user, isLoading, navigate]);

  const handleSignIn = () => {
    signIn();
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-stone-50 flex items-center justify-center">
        <Loader2 className="size-8 animate-spin text-stone-400" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-stone-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="bg-white border border-stone-200 rounded-lg p-8 shadow-sm">
          {/* Logo/Header */}
          <div className="text-center mb-8">
            <h1 className="font-serif text-3xl font-bold text-stone-900 mb-2">THE AMOR</h1>
            <p className="text-stone-600 text-sm">Luxury Resort Management</p>
          </div>

          {/* Sign In Button */}
          <Button
            onClick={handleSignIn}
            className="w-full bg-stone-900 text-white px-6 py-3 rounded text-sm tracking-widest uppercase font-semibold hover:bg-stone-800 transition-colors"
          >
            <Lock className="size-4 mr-2" />
            Sign in with Stardeck
          </Button>

          {/* Info Text */}
          <div className="mt-6 text-center">
            <p className="text-xs text-stone-500">Admin access required for resort management</p>
          </div>
        </div>

        {/* Back to Site */}
        <div className="mt-4 text-center">
          <Link to="/" className="text-sm text-stone-600 hover:text-stone-900 transition-colors">
            ← Back to website
          </Link>
        </div>
      </div>
    </div>
  );
}
